import MsgToast from '@/components/msMessageToast/msMessageToast';
import MsgToastV2 from '@/components/msMessageToast/msMessageToastV2';
import commonFunc from '@/common/commonFunction';
let popupItems = {};
class MessageToast {
    async show(config) {
        let instance = await commonFunc.getPopupInstanceAsync(popupItems, MsgToast);
        instance.showPopup(config);
    }

    async showV2(config) {
        let instance = await commonFunc.getPopupInstanceAsync(popupItems, MsgToastV2);
        instance.showPopup(config);
    }
}
export default new MessageToast();